export class SettingsProxyModel {
  autoDetectProxySettings = true;
  address = '';
  port = '';
  useAuth: boolean;
  domainName = '';
  user = '';
  password = '';
  enabled = false;

  constructor() {}
}
